/**
 * FIN permission codes used by the web (`fin.resource.action`).
 * Mirrors the backend `definePermissions('fin', …)` in api/src/modules/fin/permissions.ts.
 */
export const P = {
  account: { read: 'fin.account.read', create: 'fin.account.create', update: 'fin.account.update', roles: 'fin.account.configure_roles' },
  journal: { read: 'fin.journal_entry.read', create: 'fin.journal_entry.create', post: 'fin.journal_entry.post', reverse: 'fin.journal_entry.reverse', export: 'fin.journal_entry.export' },
  recurring: { manage: 'fin.recurring_journal.manage', approve: 'fin.recurring_journal.approve' },
  period: { read: 'fin.period.read', softClose: 'fin.period.soft_close', close: 'fin.period.close', reopen: 'fin.period.reopen', yearClose: 'fin.year.close' },
  close: { read: 'fin.close.read', update: 'fin.close.update' },
  ar: { read: 'fin.ar.read' },
  ap: { read: 'fin.ap.read', approveInvoice: 'fin.ap_invoice.approve' },
  allocation: { create: 'fin.allocation.create', reverse: 'fin.allocation.reverse' },
  ecl: { run: 'fin.ecl.run' },
  receipt: { read: 'fin.receipt.read', create: 'fin.receipt.create', post: 'fin.receipt.post', cancel: 'fin.receipt.cancel' },
  payment: { read: 'fin.payment.read', create: 'fin.payment.create', approve: 'fin.payment.approve', post: 'fin.payment.post' },
  expense: { create: 'fin.expense_invoice.create', post: 'fin.expense_invoice.post', reverse: 'fin.expense_invoice.reverse' },
  bank: { read: 'fin.bank_account.read', configure: 'fin.bank_account.configure', readIban: 'fin.bank_account.read_iban', transfer: 'fin.bank_transfer.create' },
  cheque: { read: 'fin.cheque.read', update: 'fin.cheque.update' },
  recon: { read: 'fin.reconciliation.read', perform: 'fin.reconciliation.perform' },
  custody: { read: 'fin.custody.read', create: 'fin.custody.create', approve: 'fin.custody.approve', settle: 'fin.custody.settle' },
  asset: { read: 'fin.asset.read', create: 'fin.asset.create', post: 'fin.asset.post', depreciate: 'fin.depreciation.run' },
  budget: { read: 'fin.budget.read', create: 'fin.budget.create', approve: 'fin.budget.approve' },
  fx: { run: 'fin.fx_revaluation.run' },
  statement: { read: 'fin.statement.read', configure: 'fin.statement.configure' },
  report: { read: 'fin.report.read' },
  equity: { read: 'fin.equity.read', create: 'fin.equity.create', approve: 'fin.equity.approve' },
  auditorPack: { export: 'fin.auditor_pack.export' },
  ledgerCheck: { read: 'fin.ledger_check.read' },
  dashboard: { read: 'fin.dashboard.read' },
  rpt: { run: 'rpt.report.run' },
} as const;
